if (!customElements.get('shop-the-look-look')) {
  customElements.define(
    'shop-the-look-look',
    class ShopTheLookLook extends HTMLElement {
      constructor() {
        super();
        this.cart = document.querySelector('cart-drawer');
        this.errorEl = this.querySelector('[data-look-error]');

        this.querySelectorAll('[data-look-point]').forEach((point) => {
          point.addEventListener('click', () => this.highlight(point));
        });

        this.querySelectorAll('[data-look-add-single]').forEach((button) => {
          button.addEventListener('click', () => this.addItems(button, [this.getItem(button.closest('[data-look-item]'))]));
        });

        const addAll = this.querySelector('[data-look-add-all]');
        if (addAll) {
          addAll.addEventListener('click', () => {
            const items = Array.from(this.querySelectorAll('[data-look-item]'))
              .filter((item) => !item.querySelector('[data-look-add-single][disabled]'))
              .map((item) => this.getItem(item));
            this.addItems(addAll, items);
          });
        }
      }

      getItem(item) {
        const select = item.querySelector('[data-look-variant-select]');
        const hidden = item.querySelector('[data-look-variant-id]');
        const id = select ? select.value : hidden ? hidden.value : null;
        return { id, quantity: 1 };
      }

      highlight(point) {
        this.querySelectorAll('[data-look-point]').forEach((p) => p.classList.remove('is-active'));
        this.querySelectorAll('[data-look-item]').forEach((i) => i.classList.remove('is-active'));

        point.classList.add('is-active');
        const target = this.querySelector(`#${point.dataset.target}`);
        if (target) {
          target.classList.add('is-active');
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      addItems(button, items) {
        items = items.filter((item) => item.id);
        if (!items.length) return;

        this.hideError();
        button.setAttribute('aria-disabled', 'true');
        button.disabled = true;
        button.classList.add('is-loading');

        const body = { items };
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message);
              return;
            }
            if (this.cart) {
              this.cart.renderContents(response);
            } else {
              window.location = window.routes ? window.routes.cart_url : '/cart';
            }
          })
          .catch(() => this.showError())
          .finally(() => {
            button.removeAttribute('aria-disabled');
            button.disabled = false;
            button.classList.remove('is-loading');
          });
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message || this.errorEl.dataset.defaultMessage || '';
        this.errorEl.classList.remove('hidden');
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.classList.add('hidden');
      }
    }
  );
}
